export default "__VITE_ASSET__BuFTUk3P__"